import {createFeature, createReducer, on} from "@ngrx/store";
import {APP_CONSTANTS} from "../../app.constants";
import {FilterInterface, PaginationInfoInterface, TechnologyModel} from "../../interfaces";
import * as TechnologyActions from "../actions/technologies.actions";

export const technologiesFeatureKey = "Technologies";

export interface State {
  technologyItems: Array<TechnologyModel>;
  technologyItemsPaginated: Array<TechnologyModel>;
  technologyFilters: FilterInterface;
  technologyPaginationInfo: PaginationInfoInterface;
}

export const initialState: State = {
  technologyItems: [],
  technologyItemsPaginated: [],
  technologyFilters: {
    limit: APP_CONSTANTS.PAGINATION_PAGE_SIZE,
    offset: 0
  },
  technologyPaginationInfo: {
    from: 0,
    to: 0,
    totalResults: 0,
    currentPage: 0,
    totalPages: 1
  }
};

export const technologiesFeature = createFeature({
  name: technologiesFeatureKey,
  reducer: createReducer(
    initialState,
    on(
      TechnologyActions.addTechnology,
      (state: State, {technology}): State => ({
        ...state,
        technologyItems: [...state.technologyItems, technology]
      })
    ),
    on(TechnologyActions.addTechnologies, (state: State, {technologies}): State => {
      const newTechnologies = [...state.technologyItems, ...technologies];
      return {
        ...state,
        technologyItems: newTechnologies
      };
    }),
    on(TechnologyActions.updateTechnology, (state: State, {technology}): State => {
      const technologies = state.technologyItems.map(item => (item.id === technology.id ? technology : item));
      return {
        ...state,
        technologyItems: technologies
      };
    }),
    on(
      TechnologyActions.setTechnologies,
      (state: State, {technologies}): State => ({
        ...state,
        technologyItems: technologies
      })
    ),
    on(
      TechnologyActions.setPaginatedTechnologies,
      (state: State, {technologies}): State => ({
        ...state,
        technologyItemsPaginated: technologies
      })
    ),
    on(
      TechnologyActions.setTechnologiesPaginationInfo,
      (state: State, {paginationInfo}): State => ({...state, technologyPaginationInfo: paginationInfo})
    ),
    on(
      TechnologyActions.gotoTechnologiesPage,
      (state: State, {page}): State => ({
        ...state,
        technologyFilters: {...state.technologyFilters, offset: state.technologyFilters.limit * (page - 1)},
        technologyPaginationInfo: {...state.technologyPaginationInfo, currentPage: page}
      })
    ),
    on(TechnologyActions.applyTechnologiesFilters, (state: State, {filters}): State => {
      const newFilters = {...state.technologyFilters};
      filters.forEach(({key, value}) => {
        newFilters[key as string] = value;
      });
      newFilters.offset = 0;
      return {...state, technologyFilters: newFilters};
    }),
    on(
      TechnologyActions.resetTechnologiesFilters,
      (state: State): State => ({...state, technologyFilters: initialState.technologyFilters})
    )
  )
});

export const {
  name,
  reducer,
  selectTechnologiesState,
  selectTechnologyItems,
  selectTechnologyItemsPaginated,
  selectTechnologyFilters,
  selectTechnologyPaginationInfo
} = technologiesFeature;
